import { useCallback, useEffect, useState } from "react";
import clsx from 'clsx'
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import VerticalLinearStepper from "./VerticalLinearStepper";
import { IRegimeTributario } from "../../interfaces/IRegimeTributario";
import RegimeTributarioService from "../../services/RegimeTributarioService";
import { IEmpresas } from "../../interfaces/IEmpresas";
import EmpresasModal from "../empresas/EmpresasModal";
import EmpresasService from "../../services/EmpresasService";
import ImportarService from "../../services/ImportarService";
import { useHistory } from "react-router";
import { limparDados } from "../relatorios/RelatorioSelecionarCliente";
import { Tipo } from "../relatorios/Relatorio";
import ReactS3Client from 'react-aws-s3-typescript';
import { configBucket } from "../../utils/S3Utils";
import Swal from "sweetalert2";

const steps = {
    0: { name: 'ECD', enabled: true, id: 0 },
    1: { name: 'Contas e Caixas', enabled: true, id: 1 } ,
    2: { name: 'Obrigação Acessória', enabled: true, id: 2 } ,
    3: { name: 'NF Serviços prestados', enabled: false, id: 3 },
    4: { name: 'Livro Caixa do Produtor Rural', enabled: false, id: 4 } ,
    5: { name: 'XML de saídas', enabled: false, id: 5 }, 
    6: { name: 'XML de entradas', enabled: false, id: 6 }, 
    7: { name: 'SPED Fiscal', enabled: false, id: 7 }, 
    8: { name: 'SPED Contribuições', enabled: false, id: 8 }, 
    9: { name: 'SEFIP', enabled: false, id: 9 }, 
    10: { name: 'DCTF', enabled: false, id: 10 }, 
    11: { name: 'DIRF', enabled: false, id: 11 }, 
    12: { name: 'ECF', enabled: false, id: 12 }
}

const EmpresaCol = ({ empresa, regimes, regimeSelecionado, setEmpresa }: { empresa: IEmpresas | null, regimes: IRegimeTributario[], regimeSelecionado: string, setEmpresa: Function }) => {
    const [showModal, setShowModal] = useState<boolean>(false);

    async function toggleModal(carregarEmpresa?: boolean): Promise<void> {
        let show = !showModal;
        setShowModal(show);

        if (show === false) {
            if (carregarEmpresa && empresa) {
                const result = await EmpresasService.obterPorId(empresa.id);
                setEmpresa(result);
            }
        }
    }

    return (
        <div className="col-md-5">
            {
                empresa &&
                <>
                    <label style={{ fontSize: '0.875em', color: '#aaa' }}>Razão Social</label>
                    <h3>{empresa.nomeFantasia || empresa.razaoSocial}</h3>
                    <label style={{ fontSize: '0.875em', color: '#aaa' }}>CNPJ</label>
                    <h3>{empresa.cnpj || 'CNPJ não foi importado'}</h3>
                    <label style={{ fontSize: '0.875em', color: '#aaa' }}>Regime Tributário</label>
                    <h3>{regimes.find(r => r.id === parseInt(regimeSelecionado))?.nome || "Regime não encontrado"}</h3>
    
                    <EmpresasModal empresa={empresa} title="Empresa" show={showModal} toggleModal={toggleModal} />
                    <div style={{ cursor: 'pointer', borderRadius: '10px', border: '2px solid #eda12f', backgroundColor: '#f2dba0', marginTop: '20px', padding: '15px 0 10px 40px', maxWidth: '240px', width:'100%' }} onClick={() => {
                        setShowModal(true);
                    }}>
                        <h3 style={{ color: '#ed9715' }}>Cadastro incompleto.</h3>
                        <label style={{ paddingLeft: '10px', color: '#eda12f' }}>Deseja continuar agora?</label>
                    </div>
                </>
            }
        </div>
    )
}

const ImportarContasCaixa = ({ tituloImportacao, empresa, handleNext }: { tituloImportacao: string, empresa: IEmpresas | null, handleNext: Function }) => {
    const [validating, setValidating] = useState<boolean>(false);
    const [disable, setDisable] = useState<boolean>(false);
    const [filaAtual, setFilaAtual] = useState<number>(0);
    const [totalItens, setTotalItens] = useState<number>(0);
    const [contas, setContas] = useState<any[]>([]);
    const [contaAtual, setContaAtual] = useState<any>(null);
    const [error, setError] = useState<boolean>(false);
    const [sending, setSending] = useState<boolean>(false);
    const history = useHistory();

    const sendFile = useCallback(async (file: File) => {
        setSending(true);
        if (!file) {
            setSending(false);
            Swal.fire({
                text: 'Por favor selecione um arquivo',
                timer: 3000,
                icon: 'error',
                showConfirmButton: false
            });

            return false;
        }

        const s3 = new ReactS3Client(configBucket);
        const result = await s3.uploadFile(file, file.name.split('.')[0]);
        await ImportarService.enviarArquivoExtrato(empresa?.esteiraImportada || 0, contaAtual.conta, result?.location || '', result?.key || '', 'Arquivo importado sucesso');
        setSending(false);
    }, [contaAtual, empresa, handleNext]);

    useEffect(() => {
        const load = async () => {
            setValidating(true);
            if (empresa) {
                const result = await ImportarService.getBancosContas(empresa.esteiraImportada || 0, (data) => {
                    setValidating(false);
                    setContas(data);
                    setContaAtual(data[0]);
                });

                if (!result) {
                    setError(true);
                    setValidating(false);
                    handleNext();
                }
            }
        }

        load();
    }, [empresa]);



    return (
        <div className="col-md-6" style={{ margin:'0 30px 0 10px'}}>
            <>
                <input style={{ display: 'none' }} id="inputFile2" type="file" onChange={(e) => {
                    if (e.target.files !== null && e.target.files.length > 0) {
                        const file = e.target.files[0];
                        sendFile(file);
                    }
                }} />
                {!validating && !error && (
                    <div className="col-md-12 mt-5">
                        <h5 style={{ fontStyle: 'italic', color: 'gray' }}>Foram encontradas: {contas.length} pendências de importação de extratos.</h5>
                        <h6>Banco atual: {contaAtual?.descricao}</h6>
                    </div>
                )}
                {!validating && !error && (
                    <div onClick={() => {
                        const input = document.getElementById("inputFile2");
                        input?.click();
                    }} className="col-md-12 mt-5" style={{ border: '2px dashed #8E92B8', textAlign: 'center', borderRadius: '10px', cursor: 'pointer', width: "100%" }}>
                        <div className="dropzone " id="upload" >
                            <div className="mt-5 mb-5">
                                {
                                    sending ?
                                        <>
                                            <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-sm' style={{ marginRight: '5px' }}/>
                                                Carregando
                                            </span>
                                        </>
                                        :
                                        <>
                                            <i className="bi bi-cloud-arrow-up fs-5x azul-agriholmes"/>
                                            <span className="azul-agriholmes" style={{ fontFamily: 'Cairo', fontSize: '1.875em' }}> <br />Importar {tituloImportacao} <br /> ou <br /></span>

                                            <button className='btn btn-sm btn-primario' type='submit'>
                                                <span style={{ verticalAlign: 'middle' }}> SELECIONE O ARQUIVO </span>
                                            </button>
                                        </>
                                }
                            </div>
                        </div>
                    </div>
                )}
            </>

            {!error && !validating && (
                <div style={{ display: 'flex', marginTop: '20px', justifyContent: 'space-between', alignItems: 'center' }}>
                    <button disabled={empresa === null || empresa.id === undefined} style={{ height: '40px', fontWeight: 800 }} className='btn btn-sm btn-primario' onClick={() => {
                        limparDados();
                        localStorage.setItem(`${Tipo.Relatorio}`, empresa?.razaoSocial ?? "");
                        history.push(`relatorio/${empresa?.id ?? 0}`);
                    }}>
                        RELATÓRIO
                        <i style={{ marginLeft: '10px' }} className="icon-lg text-white bi bi-pie-chart"/>
                    </button>
                    <h5>{filaAtual + 1} de {contas.length}</h5>
                    <button onClick={() => handleNext()}  style={{ height: '40px', fontWeight: 800 }} className='btn btn-sm btn-primario'>
                        Próximo
                    </button>
                </div>
            )}
        </div>
    )
}

const ImportarObrigacaoAcessoria = ({ handleNext, empresa } : { handleNext: Function, empresa: IEmpresas | null }) => {

    const [sending, setSending] = useState<boolean>(false);


    const sendFile = useCallback(async (file: File) => {
        setSending(true);
        if (!file) {
            setSending(false);
            Swal.fire({
                text: 'Por favor selecione um arquivo',
                timer: 3000,
                icon: 'error',
                showConfirmButton: false
            });

            return false;
        }

        const s3 = new ReactS3Client(configBucket);
        const result = await s3.uploadFile(file, file.name.split('.')[0]);
        await ImportarService.enviarArquivoObrigacaoAcessoria(empresa?.esteiraImportada || 0, result?.location || '', result?.key || '', 'Arquivo importado sucesso');
        setSending(false);
    }, [empresa, handleNext]);

    return (
        <div className="col-md-6" style={{ margin:'0 30px 0 10px'}}>
            <>
                <input style={{ display: 'none' }} id="inputFile2" type="file" onChange={(e) => {
                    if (e.target.files !== null && e.target.files.length > 0) {
                        const file = e.target.files[0];
                        sendFile(file);
                    }
                }} />
                <div onClick={() => {
                    const input = document.getElementById("inputFile2");
                    input?.click();
                }} className="col-md-12 mt-5" style={{ border: '2px dashed #8E92B8', textAlign: 'center', borderRadius: '10px', cursor: 'pointer', width: "100%" }}>
                    <div className="dropzone " id="upload" >
                        <div className="mt-5 mb-5">
                            {
                                sending ?
                                    <>
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-sm' style={{ marginRight: '5px' }}/>
                                            Carregando
                                        </span>
                                    </>
                                    :
                                    <>
                                        <i className="bi bi-cloud-arrow-up fs-5x azul-agriholmes"/>
                                        <span className="azul-agriholmes" style={{ fontFamily: 'Cairo', fontSize: '1.875em' }}> <br />Importar Conciliação Geral <br /></span>

                                        <button className='btn btn-sm btn-primario' type='submit'>
                                            <span style={{ verticalAlign: 'middle' }}> SELECIONE O ARQUIVO </span>
                                        </button>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </>

            <div style={{ display: 'flex', marginTop: '20px', justifyContent: 'flex-end', alignItems: 'center' }}>
                <button onClick={() => handleNext()}  style={{ height: '40px', fontWeight: 800 }} className='btn btn-sm btn-primario'>
                    Próximo
                </button>
            </div>
        </div>
    );
}

const ImportarECD = ({ file, empresa, handleNext, regimeSelecionado, uploadToS3, getTimerFile, tituloImportacao, setProgresso, setFazendoImportacao, setFile, setEmpresa, fazendoImportacao, setRegimeSelecionado, regimes }: { regimes: IRegimeTributario[], regimeSelecionado: string, setFazendoImportacao: Function, tituloImportacao: string, setRegimeSelecionado: Function, file: File | null, empresa: IEmpresas | null, handleNext: Function, uploadToS3: Function, getTimerFile: Function, setProgresso: Function, setFile: Function, setEmpresa: Function, fazendoImportacao: boolean, }) => {
    const history = useHistory();
    const funcaoSucesso = useCallback((data: IEmpresas) => {
        setFile(undefined);
        setEmpresa(data);
        handleNext();
    }, []);


    const importarECD = useCallback(async () => {
        const timer = getTimerFile();
        try {
            setFazendoImportacao(true);
            const result = await uploadToS3();
            await ImportarService.enviarArquivo(regimeSelecionado, result?.location || '', result?.key || '', funcaoSucesso, 'ECD importado sucesso');
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        } finally {
            clearInterval(timer);
            setProgresso(0);
            setFazendoImportacao(false);
        }

    }, [regimeSelecionado, uploadToS3, getTimerFile]);

    return (
        <div className="col-md-6" style={{ margin:'0 30px 0 10px'}}>
            { 
                !fazendoImportacao && 
                    <div style={{ width: '200px', margin: '0 auto' }}>
                        <select onChange={e => {
                            setRegimeSelecionado(e.target.value)
                        }} style={{ backgroundColor: 'white' }} placeholder="Selecione" className="form-select" id="form-mensagem-item">
                            <option value="" className="form-label">Regime Tributario</option>
                            {
                                regimes.map((x, index) => <option key={index} value={x.id} className="form-label">{x.nome}</option>)
                            }
                        </select>
                    </div>
            }

            <>
                <input style={{ display: 'none' }} id="inputFile" type="file" onChange={(e) => {
                    if (e.target.files !== null && e.target.files.length > 0) {
                        const file = e.target.files[0];
                        setFile(file);
                    }
                }} />
                <div onClick={() => {
                    const input = document.getElementById("inputFile");
                    setFile(undefined);
                    setProgresso(0);
                    input?.click();
                }} className="col-md-12 mt-5" style={{ border: '2px dashed #8E92B8', textAlign: 'center', borderRadius: '10px', cursor: 'pointer', width: "100%" }}>
                    <div className="dropzone " id="upload" >
                        <div className="mt-5 mb-5">
                            {
                                file ?
                                    <span className="azul-agriholmes" style={{ fontFamily: 'Cairo', fontSize: '1.500em' }}> {file.name}</span>
                                    :
                                    <>
                                        <i className="bi bi-cloud-arrow-up fs-5x azul-agriholmes"/>
                                        <span className="azul-agriholmes" style={{ fontFamily: 'Cairo', fontSize: '1.875em' }}> <br />Importar {tituloImportacao} <br /> ou <br /></span>

                                        <button className='btn btn-sm btn-primario' type='submit'>
                                            <span style={{ verticalAlign: 'middle' }}> SELECIONE O ARQUIVO </span>
                                        </button>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </>

            <div style={{ display: 'flex', marginTop: '20px', justifyContent: 'space-between', alignItems: 'center' }}>
                <button disabled={empresa === null || empresa.id === undefined} style={{ height: '40px', fontWeight: 800, marginRight: 'auto' }} className='btn btn-sm btn-primario' onClick={() => {
                    limparDados();
                    localStorage.setItem(`${Tipo.Relatorio}`, empresa?.razaoSocial ?? "");
                    history.push(`relatorio/${empresa?.id ?? 0}`);
                }}>
                    RELATÓRIO
                    <i style={{ marginLeft: '10px' }} className="icon-lg text-white bi bi-pie-chart"/>
                </button>
                <button onClick={importarECD} disabled={fazendoImportacao || !file || !regimeSelecionado}  style={{ height: '40px', fontWeight: 800 }} className='btn btn-sm btn-primario'>
                    {
                        fazendoImportacao ?
                            <span className='indicator-progress' style={{ display: 'block' }}>
                                <span className='spinner-border spinner-border-sm' style={{ marginRight: '5px' }}/>
                                Carregando
                            </span>
                        :
                            <>
                                CONTINUAR
                                <span style={{ marginLeft: '10px' }} className="icon-lg text-white bi bi-arrow-right" />
                            </>
                    }
                </button>
            </div>
        </div>
    )
}

const Importar = () => {
    const [activeStep, setActiveStep] = useState<number>(parseInt(Object.keys(steps)[0]));
    const [fazendoImportacao, setFazendoImportacao] = useState<boolean>(false);
    const { classes } = useLayout();
    const [empresa, setEmpresa] = useState<IEmpresas | null>(null);
    const [regimes, setRegimes] = useState<IRegimeTributario[]>([]);
    const [regimeSelecionado, setRegimeSelecionado] = useState<string>('');
    const [tituloImportacao, setTituloImportacao] = useState<string>(steps[0].name);
    const [file, setFile] = useState<File>();
    const [progresso, setProgresso] = useState<number>(0);

    const getRegimesTributarios = useCallback(async () => {
        return await RegimeTributarioService.obterTodos();
    }, []);

    const handleNext = useCallback(() => {
        setActiveStep((prevActiveStep) => {
            const next = parseInt(Object.keys(steps)[prevActiveStep + 1]) || null;
            if (next) {
                return  prevActiveStep + 1;
            } 
            return prevActiveStep;
        });
    }, []);

    const uploadToS3 = useCallback(async () => {
        try {
            if (file) {
                const s3 = new ReactS3Client(configBucket);
                const res = await s3.uploadFile(file, file.name);
                return res;
            }
        } catch (err) {
            throw new Error('Ocorreu um erro ao salvar o arquivo, entre em contato com o suporte ou tente novamente mais tarde!')
        }
    }, [file]);

    const getTimerFile = useCallback(() => {
        return setInterval(() => {
            setProgresso((progresso) => progresso < 100 ? progresso + 1 : progresso);
        }, ((file?.size ?? 1) / 1150));
    }, [file]);


    useEffect(() => {
        getRegimesTributarios().then((result: IRegimeTributario[]) => setRegimes(result));
    }, [getRegimesTributarios]);

    useEffect(() => {
        if (activeStep == 1) {
            setTituloImportacao(steps[1].name);
        }
    }, [activeStep])

    return <>
        <PageTitle breadcrumbs={[]}>Importar arquivos</PageTitle>
        <div className='toolbar' id='kt_toolbar'>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                <DefaultTitle />
            </div>
        </div>
        <div className="row">
            <div className="col-md-12" style={{ display: 'flex' }}>
                <div className="col-md-9">
                    <div className="row">
                        <div className="col-md-5" />
                        <div className="col-md-6">
                            <label htmlFor="file" style={{ fontWeight: 600 }}>{tituloImportacao}</label>
                            <progress id="file" value={progresso} max="100" />
                        </div>
                    </div>  
                    <div className="row">
                        <EmpresaCol empresa={empresa} regimes={regimes} regimeSelecionado={regimeSelecionado} setEmpresa={setEmpresa} />
                        {
                            activeStep === parseInt(Object.keys(steps)[0]) && <ImportarECD empresa={empresa || null} regimes={regimes} regimeSelecionado={regimeSelecionado} setEmpresa={setEmpresa}
                            setFazendoImportacao={setFazendoImportacao} fazendoImportacao={fazendoImportacao} file={file || null} getTimerFile={getTimerFile}
                            handleNext={handleNext} setFile={setFile} setProgresso={setProgresso} setRegimeSelecionado={setRegimeSelecionado} tituloImportacao={tituloImportacao}
                            uploadToS3={uploadToS3} />
                        }
                        {
                            activeStep === parseInt(Object.keys(steps)[1]) && <ImportarContasCaixa tituloImportacao={tituloImportacao} empresa={empresa} handleNext={handleNext} />
                        }
                        {
                            activeStep === parseInt(Object.keys(steps)[2]) && <ImportarObrigacaoAcessoria handleNext={handleNext} empresa={empresa} />
                        }
                    </div>
                </div>
                <div className="col-md-3 mt-5" style={{ margin: '0 10px' }}>
                    <VerticalLinearStepper activeStep={activeStep} />
                </div>
            </div>
        </div>
    </>
};


export default Importar;